export default "__VITE_ASSET__kzH7_DOx__"